import { WrestballGameLogTypes } from '../models/wrestball-game-log';
import { Locales } from './locales';

export const WrestballGameLogTypeLocalization = {
  [Locales.ru]: {
    [WrestballGameLogTypes.enter_game]: 'Выход на площадку',
    [WrestballGameLogTypes.exit_game]: 'Ушел с площадки',
    [WrestballGameLogTypes.remove_game]: 'Удаление с площадки',
    [WrestballGameLogTypes.two_point_attempt]: 'Бросок 2 очка',
    [WrestballGameLogTypes.three_point_attempt]: 'Бросок 3 очка',
    [WrestballGameLogTypes.free_throw_attempt]: 'Штрафной бросок 1 очко',
    [WrestballGameLogTypes.two_point_free_throw_attempt]: 'Штрафной бросок 2 очка',
    [WrestballGameLogTypes.three_point_free_throw_attempt]: 'Штрафной бросок 3 очка',
    [WrestballGameLogTypes.one_point_attempt]: 'Бросок 1 очко',
    [WrestballGameLogTypes.two_point_made]: '2 очка',
    [WrestballGameLogTypes.three_point_made]: '3 очка',
    [WrestballGameLogTypes.free_throw_made]: '1 очко, штрафной',
    [WrestballGameLogTypes.two_point_free_throw_made]: '2 очка, штрафной',
    [WrestballGameLogTypes.three_point_free_throw_made]: '3 очка, штрафной',
    [WrestballGameLogTypes.one_point_made]: '1 очко',
    [WrestballGameLogTypes.dunk_made]: '2 очка, данк',
    [WrestballGameLogTypes.dunk_attempt]: 'Попытка данка',
    [WrestballGameLogTypes.assist]: 'Передача',
    [WrestballGameLogTypes.block]: 'Блокшот',
    [WrestballGameLogTypes.rebound]: 'Подбор',
    [WrestballGameLogTypes.offensive_rebound]: 'Подбор в нападении',
    [WrestballGameLogTypes.defensive_rebound]: 'Подбор в защите',
    [WrestballGameLogTypes.steal]: 'Перехват',
    [WrestballGameLogTypes.turnover]: 'Потеря',
    [WrestballGameLogTypes.personal_foul]: 'Фол',
    [WrestballGameLogTypes.timeout]: 'Таймаут',
    [WrestballGameLogTypes.team_rebound]: 'Командный подбор',
    [WrestballGameLogTypes.scrum]: 'Схватка',
    [WrestballGameLogTypes.scrum_won]: 'Схватка выиграна',
    [WrestballGameLogTypes.scrum_lost]: 'Схватка проиграна',
    [WrestballGameLogTypes.scrum_tie]: 'Схватка в ничью',
    [WrestballGameLogTypes.wrestler_scrum]: 'Атака рестлера',
    [WrestballGameLogTypes.wrestler_scrum_won]: 'Атака рестлера успешна',
    [WrestballGameLogTypes.wrestler_scrum_lost]: 'Атака рестлера неудачна',
    [WrestballGameLogTypes.wrestler_scrum_tie]: 'Атака рестлера в ничью',
    [WrestballGameLogTypes.wrestler_scrum_counterattack]: 'Контратака на рестлере',
    [WrestballGameLogTypes.scrum_ball_advantage_won]: 'Схватка за начало выиграна',
    [WrestballGameLogTypes.scrum_ball_advantage_lost]: 'Схватка за начало проиграна',
    [WrestballGameLogTypes.scrum_ball_advantage_tie]: 'Схватка за начало в ничью',
    [WrestballGameLogTypes.yellow_card]: 'Желтая карточка',
    [WrestballGameLogTypes.red_card]: 'Красная карточка',
  },
  [Locales.en]: {
    [WrestballGameLogTypes.enter_game]: 'Entering the court',
    [WrestballGameLogTypes.exit_game]: 'Exit the court',
    [WrestballGameLogTypes.remove_game]: 'Removal from the court',
    [WrestballGameLogTypes.two_point_attempt]: 'Throw 2 points',
    [WrestballGameLogTypes.three_point_attempt]: 'Throw 3 points',
    [WrestballGameLogTypes.free_throw_attempt]: 'Free throw 1 point',
    [WrestballGameLogTypes.two_point_free_throw_attempt]: 'Free throw 2 points',
    [WrestballGameLogTypes.three_point_free_throw_attempt]: 'Free throw 3 points',
    [WrestballGameLogTypes.one_point_attempt]: 'Throw 1 point',
    [WrestballGameLogTypes.two_point_made]: '2 points',
    [WrestballGameLogTypes.three_point_made]: '3 points',
    [WrestballGameLogTypes.free_throw_made]: '1 point, free throw',
    [WrestballGameLogTypes.two_point_free_throw_made]: '2 points, free throw',
    [WrestballGameLogTypes.three_point_free_throw_made]: '3 points, free throw',
    [WrestballGameLogTypes.one_point_made]: '1 point',
    [WrestballGameLogTypes.dunk_made]: '2 points, dunk',
    [WrestballGameLogTypes.dunk_attempt]: 'Dunk attempt',
    [WrestballGameLogTypes.assist]: 'Assist',
    [WrestballGameLogTypes.block]: 'Block',
    [WrestballGameLogTypes.rebound]: 'Rebound',
    [WrestballGameLogTypes.offensive_rebound]: 'Offensive rebound',
    [WrestballGameLogTypes.defensive_rebound]: 'Defensive rebound',
    [WrestballGameLogTypes.steal]: 'Steal',
    [WrestballGameLogTypes.turnover]: 'Turnover',
    [WrestballGameLogTypes.personal_foul]: 'Personal foul',
    [WrestballGameLogTypes.timeout]: 'Timeout',
    [WrestballGameLogTypes.team_rebound]: 'Team rebound',
    [WrestballGameLogTypes.scrum]: 'Scrum',
    [WrestballGameLogTypes.scrum_won]: 'Scrum is won',
    [WrestballGameLogTypes.scrum_lost]: 'Scrum is lost',
    [WrestballGameLogTypes.scrum_tie]: 'Scrum is in a draw',
    [WrestballGameLogTypes.wrestler_scrum]: 'Wrestler attack',
    [WrestballGameLogTypes.wrestler_scrum_won]: 'Successful Wrestler attack',
    [WrestballGameLogTypes.wrestler_scrum_lost]: 'Unsuccessful Wrestler attack',
    [WrestballGameLogTypes.wrestler_scrum_tie]: 'Wrestler\'s attack in a draw',
    [WrestballGameLogTypes.wrestler_scrum_counterattack]: 'Counterattack on the wrestler',
    [WrestballGameLogTypes.scrum_ball_advantage_won]: 'Scrum for the beginning is won',
    [WrestballGameLogTypes.scrum_ball_advantage_lost]: 'Scrum for the beginning is lost',
    [WrestballGameLogTypes.scrum_ball_advantage_tie]: 'Scrum for the beginning is in draw',
    [WrestballGameLogTypes.yellow_card]: 'Yellow card',
    [WrestballGameLogTypes.red_card]: 'Red card',
  }
};
